import React from 'react';
import { TOKENS } from '../state/colors';

interface SparklineProps {
  values: number[];
  color?: string;
}

export const Sparkline: React.FC<SparklineProps> = ({ values, color = TOKENS.purpleSoft }) => {
  const width = 90;
  const height = 32;
  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const rango = max - min || 1;

  const points = values.map((v, i) => {
    const x = (i / Math.max(values.length - 1, 1)) * width;
    const y = height - ((v - min) / rango) * height;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });

  const last = points[points.length - 1]?.split(',').map(Number) ?? [width, height];

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} data-testid="sparkline">
      <polyline points={points.join(' ')} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={last[0]} cy={last[1]} r={3} fill={color} />
    </svg>
  );
};
